import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'

export type TSesionForm = {
  username: string
  password?: string
}

/**
 * Valida credenciales antes de pedir token OAuth al backend.
 * El frontend solo valida formato requerido; la autenticacion real ocurre en `/sec/a/t`.
 */
export const schema = yup.object({
  username: yup
    .string()
    .trim()
    .required('Por favor, introduce tu correo')
    .email('Por favor, introduce en correo válido'),
  password: yup.string().trim().required('Por favor, introduce tu contraseña'),
})

export const useSesionForm = () => {
  return useForm<TSesionForm>({
    mode: 'all',
    resolver: yupResolver(schema),
  })
}
